initBundleProductsObserver();

$('form[action="/cart/add"]').submit(sendToCart);

// This close the cart drawer
$(".button-fermer-cart").click(closeSideCart);
$(".overlay-cart").click(closeSideCart);

// this open cart with button in menu
$(".button-panier").click(openSideCart);

const cartFetch = async () => {
  let urlCart = "/cart.js";
  try {
    const response = await fetch(urlCart);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}

// this funtions button the +/- quantity
function addPlus() {
  $(
    '<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>'
  ).insertAfter(".quantity input");

  $(".quantity").each(function () {
    const spinner = $(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find(".quantity-up"),
      btnDown = spinner.find(".quantity-down"),
      min = input.attr("min"),
      max = input.attr("max");

    if(input.data('loaded-quantity-functions')) return; //continue
    
    input.data('loaded-quantity-functions', true);

    btnUp.click(function () {
      var oldValue = parseFloat(input.val());

      if (oldValue >= max) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
      
    });

    btnDown.click(function () {
      var oldValue = parseFloat(input.val());
      if (oldValue <= min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
      
    });
    
  });
}

// Transform function for price product /100
function currencyMoney(number) {
  let numberString = number / 100;
  return numberString;
}

// Transform funtion for currency value print TOTAL or SUBTOTAL
function numberTransform(stringi) {
  let NewNumber = Number(stringi);
  let numberFormat = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(NewNumber);
  return numberFormat;
}

// Function to remove item product with X
async function removeProduct() {
  $(".button-remove-cart").on("click", (e) => {
    let targetButton = e.target;
    let $idv = $(targetButton).attr("id_button_product");
    let $inputChange = $(`.input-cart[id-product="${$idv}"]`);
    $inputChange.val(0);
    $inputChange.trigger("change");
  });
}

// pint items products in cart DOM drawer
async function cartItems() {
  let printLoad = await cartFetch();
  pintDataCart(printLoad);
}

const dataValues = (dataIndex, dataFull) => {
    const btnCommander = '#btn-commander';
    let data = [];
    const containerCartt = document.getElementById("cart-items");
    if (dataIndex.length === 0) {
        const htmlEmpty = document.getElementById("display-cart-empty");
        containerCartt.innerHTML = $(htmlEmpty).html();
        $(btnCommander).attr('href', '');
        $(btnCommander).addClass('cart-emp');
    } else {
        if($(btnCommander).hasClass('cart-emp')) {
            $(btnCommander).removeClass('cart-emp');
            $(btnCommander).attr('href', '/cart');
        }
        
        if($('.site-header__cart-count').hasClass('hide')) {
            $('.site-header__cart-count').removeClass('hide');
        }
        
        data = dataFull;
        containerCartt.innerHTML = data;
    }
}

const countCart = (cc) => {
  const countInit = document.querySelectorAll(".site-header__cart-count");
  for (let v of countInit) {
    $(v.children[0]).text(cc); //`${cc}`;
  }
}

// Template for item product in cart drawer
function pintDataCart(fetchi) {
  let html = "";
  const dataPint = fetchi.items;
  dataPint.forEach((data, index) => {
    let quantityItem = data.quantity;
    let priceItem = data.price;
    let priceTotal = quantityItem * priceItem;
    let priceString = currencyMoney(priceTotal);
    let numberFormat = numberTransform(priceString);
    let imageCard;
    if (data.image){imageCard=data.image}else{imageCard="https://cdn.shopify.com/s/files/1/0528/9748/0861/files/carte-cadeu-minastorm.jpg?v=1614283204"}
    let templateProductCart = `
      <div class="template-cart-flex" id-container_product="${data.variant_id}">
        <div class="cart-container-img">
          <a href='${data.url}' title='${data.product_title}' class='cart-link'>
            <img src="${imageCard}" width="100%" height="100%" class="imageProduct_cart" alt="${data.title}"/>
          </a>
        </div>
        <div class="grid-inf-cart">
          <div class="margin-cart-product product-title-cart title-taille-group">
            <a href='${data.url}' title='${data.product_title}' class='cart-link'>
              <p class="size-font-title font-cart">${data.product_title}</p>
            </a>
            <p class="size-font-cart font-cart">Taille ${data.variant_options[1]}</p>

            <div class="margin-cart-product product-form__controls-group small--show medium-up--hide">
              <div class="item-border-aq">
                  <label class="quantity label-quantity_style" for="Quantity-${data.handle}">
                    <input type="number" id="Quantity-${data.handle}"
                      name="quantity" data-index="${index}" price_product="${priceItem}" id-product="${data.variant_id}" value="${quantityItem}" min="1" max="${priceItem > 0 ? 999 : 0}" pattern="[0-9]*"
                      class="size-font-cart font-cart product-form__input product-form__input--quantity input-cart" data-quantity-input>
                  </label>
              </div>
            </div>

          </div>
          
          <div class="margin-cart-product product-input-cart small--hide medium-up--show">
            <div class="item-border-aq">
                <label class="quantity label-quantity_style" for="Quantity-${data.handle}">
                  <input type="number" id="Quantity-${data.handle}"
                    name="quantity" data-index="${index}" price_product="${priceItem}" id-product="${data.variant_id}" value="${quantityItem}" min="1" 
                    max="${priceItem > 0 ? 999 : 0}" 
                    pattern="[0-9]*"
                    class="size-font-cart font-cart product-form__input product-form__input--quantity input-cart" data-quantity-input>
                </label>
            </div>
          </div>

          <div class="margin-cart-product product-total-cart">
            <p class="size-font-cart font-cart number-format" totalice-number="${priceTotal}" id-formatNumber="${data.variant_id}">${numberFormat}</p>
            <p class="number-suma" id_suma="${data.variant_id}">${priceTotal}</p>
          </div>

          <button class="margin-cart-product product-remove-cart button-remove-cart" id_button_product="${data.variant_id}">
            <span class="icon-close-remove top-x"></span>
            <span class="icon-close-remove down-x"></span>
          </button>

        </div>
      </div>
    `;
    html += templateProductCart;
  });
  
  let commanderButtonTotalCart = document.getElementById("commander-button-total-cart");
  $(commanderButtonTotalCart).html(`&nbsp;${(fetchi.total_price/100).toFixed(2)}&nbsp;€`);

  livrasonCount(fetchi.total_price/100);
  countCart(fetchi.item_count);
  dataValues(dataPint, html);
  addPlus();
  quantityCart();
  removeProduct();
  checkTotalIsSmallerThanGoal(fetchi.total_price/100);
}

function openSideCart() {
  $(".fixed-drawer").css({
    animation: "cartIn 1s ease forwards",
    "box-shadow": "-10px 0 25px rgb(0 0 0 / 25%);",
  });
  $(".flex-title-drawer").css("animation", "InCartItem 2s ease-in-out forwards");
  $("#cart-items").css("animation", "InCartItem 2s ease-in-out forwards");
  $(".overlay-cart").addClass("overlayActive");
}

function closeSideCart() {
  $(".fixed-drawer").css({
    animation: "cartOut 1s ease forwards",
    "box-shadow": "none",
  });
  $(".flex-title-drawer").css("animation", "OutCartItem 1s ease-in-out forwards");
  $("#cart-items").css("animation", "OutCartItem 1s ease-in-out forwards");
  $(".overlay-cart").removeClass("overlayActive");
}

function sendToCart(event) {
  event.preventDefault();

  $.ajax({
    type: 'post',
    url: '/cart/add.js',
    dataType: 'json',
    data: $(event.target).serialize(), 
    success: function() {

      $.ajax({
        url: '/cart.js',
        type: 'get',
        dataType: 'json',
        data: '',
        success: (dataCart) => {
          pintDataCart(dataCart);
          openSideCart();
        }
      });
    },
    error: function(xhr) {
        const errorMessage = '.product-form__error-message';
        const errorMessageWrapper = '.product-form__error-message-wrapper';
        const hideErrorMessage = 'product-form__error-message-wrapper--hidden';
        
        $(errorMessage).html(xhr.responseJSON.description);
        $(errorMessageWrapper).removeClass(hideErrorMessage);

        $(event.currentTarget.parentElement).append($(errorMessageWrapper));
        
        setTimeout(function() {
            $(errorMessageWrapper).addClass(hideErrorMessage);
        }, 5000);
      }
  });
}

function initBundleProductsObserver() {
  const pickyWidgetContainer = document.querySelector('.relative-form');
  let observerPicky = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if(mutation.type !== "childList" || mutation.previousSibling === null || mutation.previousSibling.classList === undefined) return;
  
      if(!mutation.previousSibling.classList.contains('checkmark')) return;
      
      cartItems();
      openSideCart();
    });
  });
  if(pickyWidgetContainer) {
    observerPicky.observe(pickyWidgetContainer, {childList: true, subtree: true});
  }
}

// this function to change quantity in cart drawer
async function quantityCart() {
  $(".input-cart").on("change", (e) => {
    
    let target = e.target;
    let $idProduct = Number($(target).attr("id-product"));
    let valueChange = Number(e.target.value);
    const line = Number(e.target.dataset.index) + 1;
    const pricee = Number($(target).attr("price_product"));
    let newTotal = pricee * valueChange;
    let priceString = currencyMoney(newTotal);
    let numberFormat = numberTransform(priceString);
    const $contianerNumber = $(
      `.number-format[id-formatNumber="${$idProduct}"]`
    );
    $contianerNumber.attr("totalice-number", newTotal);
    $(`.number-suma[id_suma="${$idProduct}"]`).text(newTotal);
    $contianerNumber.text(numberFormat);

    console.log("quantity changed" + line);
    
    updateQuantity(line, valueChange); // this function render cart
    if (!valueChange) {
      $(
        `.template-cart-flex[id-container_product="${$idProduct}"]`
      ).css("animation", "CartRemove .5s ease-in-out forwards");
    }
  });
  loadCartDrawer();
}

// this function to re-render cart after change quantity
async function updateQuantity(line, quantity) {
  fetch("/cart/change.js", {
    method: "POST",
    body: JSON.stringify({ line, quantity }),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((data) => {
      return data.json();
    })
    .then((data) => {
      pintDataCart(data);
    })
    .catch((err) => {
      console.error(err);
    });
}



  const initBootstrapScript = () => {
      if (!document.querySelector('#bootstrap-js')) {
          const script = document.createElement('script')
          script.setAttribute('id', 'bootstrap-js')
          script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.min.js')
          script.setAttribute('integrity', 'sha256-cMPWkL3FzjuaFSfEYESYmjF25hCIL6mfRSPnW8OVvM4=')
          script.setAttribute('crossorigin', 'anonymous')
          document.head.appendChild(script)
      }
  }
  initBootstrapScript()

  // Open the cart drawer by URL if contains '#cart'
  if (window.location.hash.includes('#cart')) {
      setTimeout(() => {
          const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#cart-drawer')
          offcanvas.show()
      }, 250)
  }


 // Load cart drawer on ajax add/update
 window.loadCartDrawer = async () => {
  const cartDrawer = document.querySelector('#cart-drawer')

  const cartGoal = cartDrawer.querySelector('#cart-drawer-goal')
  cartGoal.style.opacity = '.2'

  const cartUpsells = cartDrawer.querySelector('#cart-drawer-upsells-list')
  cartUpsells.style.opacity = '.2'

  const respoonse = await fetch(window.location.href)
  const data = await respoonse.text()
  
  const parser = new DOMParser()
  const newDocument = parser.parseFromString(data, 'text/html')
  
  cartGoal.replaceWith(newDocument.querySelector('#cart-drawer-goal'))
  cartUpsells.replaceWith(newDocument.querySelector('#cart-drawer-upsells-list'))

  initCartGoal()
  initCartUpsells()
  
}

const checkTotalIsSmallerThanGoal = (total) => {
  console.log("total CART" + total);
  let goal = $(".progress_step-2").data("goal2")
  if(total < goal) {
    removeFreeProductInCart();
    console.log("remove")
  } else {
    console.log("keep")
  }
}



const removeFreeProductInCart = async () => {
  let urlCart = "/cart.js";
  try {
    const response = await fetch(urlCart);
    const data = await response.json();
    data.items.forEach(item => {
      if(item.final_price == 0) {
        console.log(item.id);
        

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data:  { 
            quantity: 0, 
            id: item.id
          },
          success: function() {

            $.ajax({
              url: '/cart.js',
              type: 'get',
              dataType: 'json',
              data: '',
              success: (dataCart) => {
                pintDataCart(dataCart);
              }
            });
          }
        });
        
      }
    });
  } catch (err) {
    console.error(err);
  }
}




// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-drawer-goal .progress-bar')

    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
  initCartGoal()

  // Cart Upsells 
  const initCartUpsells = async () => {
    document.querySelectorAll('#cart-drawer-upsells-list button').forEach(btn => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault()

            const variantId = btn.closest('.cart-drawer-upsells-list-item').querySelector('select[name="id"]').value

            let data = {
              items: [{
                  id: Number(variantId),
                  quantity: 1
              }]
            };

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              success: function() {

                $.ajax({
                  url: '/cart.js',
                  type: 'get',
                  dataType: 'json',
                  data: '',
                  success: (dataCart) => {
                    pintDataCart(dataCart);
                  }
                });
              }
            });
        })
    }) 
}
initCartUpsells()

